var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bigPlayIcon",style:({color: _vm.skin.bigPlay.color})},[_c('font-awesome-icon',{attrs:{"icon":"play-circle","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }